(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // class StickyHeader extends HTMLElement {
  //   constructor() {
  //     super();
  //   }

  //   connectedCallback() {
  //     this.header = document.querySelector('.section-header');
  //     this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  //     this.headerBounds = {};

  //     this.setHeaderHeight();

  //     window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

  //     if (this.headerIsAlwaysSticky) {
  //       this.header.classList.add('shopify-section-header-sticky');
  //     };

  //     this.currentScrollTop = 0;
  //     this.preventReveal = false;
  //     this.predictiveSearch = this.querySelector('predictive-search');

  //     this.onScrollHandler = this.onScroll.bind(this);
  //     this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  //     this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //     window.addEventListener('scroll', this.onScrollHandler, false);

  //     this.createObserver();
  //   }

  //   setHeaderHeight() {
  //     document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  //   }

  //   disconnectedCallback() {
  //     this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //     window.removeEventListener('scroll', this.onScrollHandler);
  //   }

  //   createObserver() {
  //     let observer = new IntersectionObserver((entries, observer) => {
  //       this.headerBounds = entries[0].intersectionRect;
  //       observer.disconnect();
  //     });

  //     observer.observe(this.header);
  //   }

  //   onScroll() {
  //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  //     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  //     if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //       this.header.classList.add('scrolled-past-header');
  //       if (this.preventHide) return;
  //       requestAnimationFrame(this.hide.bind(this));
  //     } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //       this.header.classList.add('scrolled-past-header');
  //       if (!this.preventReveal) {
  //         requestAnimationFrame(this.reveal.bind(this));
  //       } else {
  //         window.clearTimeout(this.isScrolling);

  //         this.isScrolling = setTimeout(() => {
  //           this.preventReveal = false;
  //         }, 66);

  //         requestAnimationFrame(this.hide.bind(this));
  //       }
  //     } else if (scrollTop <= this.headerBounds.top) {
  //       this.header.classList.remove('scrolled-past-header');
  //       requestAnimationFrame(this.reset.bind(this));
  //     }

  //     this.currentScrollTop = scrollTop;
  //   }

  //   hide() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  //     this.closeMenuDisclosure();
  //     this.closeSearchModal();
  //   }

  //   reveal() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.add('shopify-section-header-sticky', 'animate');
  //     this.header.classList.remove('shopify-section-header-hidden');
  //   }

  //   reset() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  //   }

  //   closeMenuDisclosure() {
  //     this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  //     this.disclosures.forEach(disclosure => disclosure.close());
  //   }

  //   closeSearchModal() {
  //     this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  //     this.searchModal.close(false);
  //     conosle.log('close search');
  //   }
  // }

  // customElements.define('sticky-header', StickyHeader);


  let currentOpenSubMenu = null;
  const navItems = document.querySelectorAll('.nav__main-menu > .nav__item');

  navItems.forEach((item, index) => {
    const subMenu = item.querySelector('.nav__flyout-menu-container');

    // On mouseenter
    item.addEventListener('mouseenter', () => {
      if (currentOpenSubMenu) {
        currentOpenSubMenu.classList.add('nav__flyout-menu-container--hidden');
      }

      if (subMenu) {
        subMenu.classList.remove('nav__flyout-menu-container--hidden');
        currentOpenSubMenu = subMenu;
      }
    });

    // When the mouse leaves the nav item, hide the submenu
    item.addEventListener('mouseleave', () => {
      if (subMenu) {
        subMenu.classList.add('nav__flyout-menu-container--hidden');
        currentOpenSubMenu = null;
      }
    });
  });

  const navProducts = document.querySelectorAll('.nav__sub-menu-list > .nav__item');

  navProducts.forEach((item, index) => {
    let productThumbnail = item.closest('.nav__flyout-menu').querySelector('.nav__thumbnails');

    // On mouseenter
    item.addEventListener('mouseenter', () => {
      let imageSource = item.querySelector('img').src;

      if ( imageSource ) {
        let newImage = document.createElement('img');
        newImage.src = imageSource;

        // Clear the thumbnail div
        while (productThumbnail.firstChild) {
          productThumbnail.removeChild(productThumbnail.firstChild);
        }

        productThumbnail.appendChild(newImage);
      }
    });

  });


  } catch(e) { console.error(e); }
})();
})();
